import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, STORAGE_URL } from "./config";
import { useNavigate, useLocation } from "react-router-dom";
import EmployerHeader from "./EmployerHeader";
import JobSeekerHeader from "./JobSeekerHeader";
import avatar from "./assets/profile5.png";
import styles from "./assets/css/LoadingComponent.module.css";
import "./assets/css/mycircles.css";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { BsArrowLeft } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "./store/slices/UserSlice";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Helper from "./Helper";
import colors from "./colors";
import {ErrorHandlingComponent} from "./ErrorHandlingComponent";
import UserFetch from "./UserFetch";

const FollowersFollowingScreen = () => {
    const navigate = useNavigate();
    const [followers, setFollowers] = useState([]);
    const [followings, setFollowings] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("access_token");
    const [showFollowModal, setShowFollowModal] = useState(false);
    const [userToFollow, setUserToFollow] = useState(null);
    const [openTab, setOpenTab] = useState('followers')
    const location = useLocation();
    const { from } = location.state || {};
    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState(false);
    const headers = {
        Authorization: `Bearer ${token}`,
    };
    const user_data = useSelector((state) => {
        return state?.user?.user;
    });

    const userable_type = localStorage.getItem('userable_type');
    let headerComponent;
    if (userable_type === 'App\\Models\\Employer') {
        headerComponent = <EmployerHeader />;
    } else {
        headerComponent = <JobSeekerHeader />;
    };

    const getUsers = ()=>{
        setLoading(true);
        // Fetch followers and followings data from your API
        axios.get(`${BASE_URL}/followers`, { headers })
            .then((response) => {
                if (response.data.status === 200) {
                    setFollowers(response.data.user.followers);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false)
                setFetchError(true)
                setFetchErrorMessage(error)
            });

        axios.get(`${BASE_URL}/followings`, { headers })
            .then((response) => {
                if (response.data.status === 200) {
                    setFollowings(response.data.user.followings);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false)
                setFetchError(true)
                setFetchErrorMessage(error)
            });
    }

    useEffect(() => {
        getUsers()
    }, []);

    // Function to check if a user is following another user
    const isFollowing = (userId) => {
        // Implement your logic to check if the user with userId is being followed by the current user.
        // You might want to compare userId with the list of IDs in the followings array.
        return followings.some((following) => following.id === userId);
    };

    const dispatch = useDispatch();

    const handleFollowUser = (userId) => {
        // Make an API call to follow the user with the provided userId
        // Use axios or your preferred HTTP library to send the request
        setLoading(true)
        axios
            .post(`${BASE_URL}/follow`, { following_id: userId }, { headers })
            .then((response) => {
                // Handle success
                if (response?.data?.status === 200) {
                    //Update Redux
                    UserFetch()
                        .then((response) => {
                            const user_data = response.data.user;
                            // console.log(user_data, "user data");
                            dispatch(addUser(user_data));
                        })
                        .catch((error) => {
                            console.error("Error fetching user:", error);
                        });

                    let userCopy = user_data;
                    const currentFollowingsCount = userCopy.followings_count
                    userCopy = { ...userCopy, followings_count: currentFollowingsCount + 1 }
                    dispatch(addUser(userCopy))
                    getUsers()
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false)
                setFetchError(true)
                setFetchErrorMessage(error)
            });
    };

    const handleUnFollowUser = (userId) => {

        setLoading(true)
        axios
            .post(`${BASE_URL}/unfollow`, { following_id: userId }, { headers })
            .then((response) => {
                if (response?.data?.status === 200) {
                    //Update Redux
                    UserFetch()
                        .then((response) => {
                            const user_data = response.data.user;
                            // console.log(user_data, "user data");
                            dispatch(addUser(user_data));
                        })
                        .catch((error) => {
                            console.error("Error fetching user:", error);
                        });
                    let userCopy = user_data;
                    const currentFollowingsCount = userCopy.followings_count
                    userCopy = { ...userCopy, followings_count: currentFollowingsCount - 1 }
                    dispatch(addUser(userCopy))
                    getUsers()
                }
            })
            .catch((error) => {
                setLoading(false)
                setFetchError(true)
                setFetchErrorMessage(error)
            });
    }
    const showFollowUserModal = (userId) => {
        setUserToFollow(userId);
        setShowFollowModal(true);
    };

    const closeFollowUserModal = () => {
        setUserToFollow(null);
        setShowFollowModal(false);
    };

    const handleTab = ()=>{


        if(openTab === "followings"){
            setOpenTab("followers")
        }else{
            setOpenTab("followings")
        }
    }
    useEffect(()=>{}, [openTab])
    function handleUserClick (userId) {
        const from="/follow";
        const user_id=userId;
        navigate("/profile-view", { state: { from,user_id } });
    }
    return (
        <div>
            {headerComponent}
            <div className="pt-5">
                <div className="container pt-5">
                    <div className="AJbackbtn pt-5" >
                        <div className="backbtn mb-2">
                            <button onClick={() => navigate(-1)}> <BsArrowLeft /> Back </button>
                        </div>
                    </div>
                    <div className="AJheadtitle">
                        <div className="AJtitle w-100 EDJhead">
                            <h2>{user_data?.firstname ? user_data?.firstname + "’s" + " Circle" : "My Circle"}</h2>
                        </div>
                    </div>
                    {loading && (
                        <div className={styles.loadingOverlay}>
                            <div className={styles.loadingSpinner}></div>
                        </div>
                    )
                    }
                        <div>

                            <Tabs defaultActiveKey={openTab} id="tabs" className="tabs_custom" onClick={handleTab}>
                                <Tab eventKey="followers" title="Followers" >
                                    <div className="list-group pt-1 followers-list">
                                        {followers.map((follower) => (
                                            <div key={follower.id} className="list-group-item d-flex align-items-center">
                                                {Helper.profile_log(follower)}
                                                <div className="ml-2 p-1 flex-grow-1">
                                                    {follower.userable_type === "App\\Models\\JobSeeker" ? (
                                                        <span className="mb-0" role="button" onClick={() => handleUserClick(follower.id)}>
                                                            <strong>{follower.firstname} {follower.lastname}</strong> (Job Seeker)
                                                            {follower.userable.active_for_jobs === "Yes" && <strong><span style={{ color: colors.thirdColor }}> Active For Job</span></strong>}
                                                        </span>
                                                    ) : follower.userable_type === "App\\Models\\Employer" ? (
                                                        <span className="mb-0" role="button" onClick={() => handleUserClick(follower.id)}>
                                                        <strong>{follower.firstname} {follower.lastname}</strong> (Employer)
                                                      </span>
                                                    ) : (
                                                        <span className="mb-0" role="button" onClick={() => handleUserClick(follower.id)}>
                                                        <strong>{follower.firstname} {follower.lastname}</strong>
                                                        </span>
                                                    )}


                                                    {/*<h5 className="mb-0 " role="button"  onClick={() => handleUserClick(follower.id)}> {follower.firstname} {follower.lastname}</h5>*/}
                                                    <p className="mb-0">{follower.current_employee}</p>
                                                </div>
                                                <button
                                                    className="btn btn-outline-custom"
                                                    onClick={() => {
                                                        isFollowing(follower.id)
                                                            ? showFollowUserModal(follower.id)
                                                            : handleFollowUser(follower.id);
                                                    }}
                                                >
                                                    {isFollowing(follower.id) ? "Following" : "Follow Back"}
                                                </button>

                                            </div>
                                        ))}
                                        {followers.length === 0 &&(<p className="text-danger text-center">No follower found.</p>)}
                                    </div>
                                </Tab>
                                <Tab eventKey="followings" title="Followings">
                                    <div className="list-group pt-1 followings-list">
                                        {followings.map((following) => (
                                            <div key={following.id} className="list-group-item d-flex align-items-center">

                                                {Helper.profile_log(following)}
                                                <div className="ml-2 p-1 flex-grow-1">
                                                    {/*<h5 className="mb-0"*/}
                                                    {/*    role="button" onClick={() => handleUserClick(following.id)}>{following.firstname} {following.lastname}</h5>*/}

                                                    {following.userable_type === "App\\Models\\JobSeeker" ? (
                                                        <span className="mb-0" role="button" onClick={() => handleUserClick(following.id)}>
                                                            <strong>{following.firstname} {following.lastname}</strong> (Job Seeker)
                                                            {following.userable.active_for_jobs === "Yes" && <strong><span style={{ color: colors.thirdColor }}> Active For Job</span></strong>}
                                                        </span>
                                                                ) : following.userable_type === "App\\Models\\Employer" ? (
                                                                    <span className="mb-0" role="button" onClick={() => handleUserClick(following.id)}>
                                                            <strong>{following.firstname} {following.lastname}</strong>
                                                            <span> (Employer)</span>
                                                          </span>
                                                                ) : (
                                                                    <span className="mb-0" role="button" onClick={() => handleUserClick(following.id)}>
                                                            <strong>{following.firstname} {following.lastname}</strong>
                                                          </span>
                                                                                                            )}


                                                    <p className="mb-0">{following.current_employee}</p>
                                                </div>
                                                <button className="btn btn-outline-custom"
                                                        onClick={() => {
                                                               showFollowUserModal(following.id)
                                                        }}
                                                >Following</button>
                                            </div>
                                        ))}
                                        {followings.length === 0 &&(<p className="text-danger text-center">No followings found.</p>)}
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>

                </div>
            </div>
            <Modal show={showFollowModal} onHide={closeFollowUserModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Unfollow</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isFollowing(userToFollow)
                        ? "Are you sure you want to unfollow this user?"
                        : "Are you sure you want to follow this user?"}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={isFollowing(userToFollow) ? "danger" : "primary"}
                        size="sm"
                        onClick={() => {
                            isFollowing(userToFollow)
                                ? handleUnFollowUser(userToFollow)
                                : handleFollowUser(userToFollow);
                            closeFollowUserModal();
                        }}
                    >
                        {isFollowing(userToFollow) ? "Unfollow" : "Follow"}
                    </Button>
                    <Button variant="secondary" size="sm" onClick={closeFollowUserModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {fetchError &&  <ErrorHandlingComponent error={fetchErrorMessage} />}
        </div>

    );
};

export default FollowersFollowingScreen;
